// User-facing copy: notes. Moved from the web app (components/Moments.tsx, pages/club/NotesPage.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/Moments.tsx */
export const moments = {
    andSep: " and ",
    today: "today",
    aNoteWasWaiting: (spot) => `A note was waiting for you at ${spot}`,
    notesWereWaitingAt: (length, spot) => `${length} notes were waiting at ${spot}`,
    notesWereWaitingFor: (length) => `${length} notes were waiting for you`,
    message: "message",
    messages: "messages",
    meetingQuestion: "meeting question",
    meetingQuestions: "meeting questions",
    whatOpenedSinceYou: "What opened since you last looked",
    dismiss: "Dismiss",
    openedSince: (what, since) => `${what} opened since ${since}`,
    youVeReached: (name) => `You've reached ${name}`,
    nothingNewOpenedSince: (since) => `Nothing new opened since ${since}.`,
    fromTapToOpen: (name) => `From ${name} · tap to open`,
    tapToOpen: "Tap to open",
    aNoteForYou: "A note for you",
    notesForYou: (length) => `${length} notes for you`,
    keptInYourNotebook: "Kept in your notebook, at the page it was left.",
    fromAt: (name, spot, x) => `From ${name} · at ${spot}${x}`,
    edited: " · edited",
    arrived: (day) => `Arrived ${day}`,
    sharedWithTheClub: "Shared with the club",
    shareWithTheClub: "Share with the club",
    leaveANoteForward: "Leave a note forward",
    itWaitsAtA: "It waits at a page, sealed, and reaches whoever gets there after you.",
    whereItWaits: "Where it waits",
    upToWhereYou: (spot) => `Up to ${spot}, where you are.`,
    whoItSFor: "Who it's for",
    everyoneWhoGetsThere: "Everyone who gets there",
    onePerson: "One person",
    nobodyIsBehindRight: (spot) => `Nobody is behind ${spot} right now.`,
    notStarted: "Not started",
    onlyPeopleWhoHaven: (spot) => `Only people who haven't reached ${spot} yet.`,
    yourNote: "Your note",
    whatShouldTheyKnow: "What should they know when they get here?",
    left: (x) => `${x} left`,
    ofYourNotesAre: (FORWARD_NOTE_LIMIT, FORWARD_NOTE_LIMIT2) => `${FORWARD_NOTE_LIMIT} of your ${FORWARD_NOTE_LIMIT2} notes are waiting. One has to arrive or be deleted first.`,
    ofYourNotesWaiting: (waiting, FORWARD_NOTE_LIMIT) => `${waiting} of your ${FORWARD_NOTE_LIMIT} notes waiting`,
    leaveNote: "Leave note",
    yourPrediction: "Your prediction",
    sealedAtOpensWhen: (spot) => `Sealed at ${spot} · opens when you finish`,
    sealedYouCanChange: (until) => `Sealed · you can change it until ${until}`,
    edit: "Edit",
    makeAPrediction: "Make a prediction",
    beforeNobodyReadsIt: (spot) => `Before ${spot}. Nobody reads it until they finish.`,
    whoMakesItTo: "Who makes it to the end? How does it finish?",
    iThinkILl: "I think I'll give it ",
    sealItAgain: "Seal it again",
    sealIt: "Seal it",
    predictionsCloseAt: (spot) => `Predictions close at ${spot}.`,
    sealed: (plural) => `${plural} sealed`,
    prediction: "prediction",
    predictions: "predictions",
    openedReadThemAgain: "Opened · read them again",
    thePredictions: "The predictions",
    you: "You",
    sealedAt: (spot) => ` · sealed at ${spot}`,
    guessed: "Guessed ",
    gaveIt: "Gave it ",
    hasnTRatedYet: "Hasn't rated yet",
    sealedAt2: (x, spot) => `${x} · sealed at ${spot}`,
    everythingSOpen: "Everything's open",
    youFinished: (title) => `You finished ${title}.`,
    firstReaction: "first reaction",
    firstReactions: "first reactions",
    openThePredictions: "Open the predictions",
    rateItAndAdd: "Rate it and add a first reaction",
    notNow: "Not now",
};
/** pages/club/NotesPage.tsx */
export const page = {
    today: "today",
    back: "Back",
    notebookOnlyYouCan: "Notebook · only you can see this",
    notes: "Notes",
    leftForYou: "Left for you",
    yourNotes: "Your notes",
    nothingYetJotAs: "Nothing yet. Jot as you read; share a note with the club when it's ready, or keep it to yourself.",
    emptyTitle: "Nothing jotted yet",
    emptyBody: "Thoughts and passages, each pinned to where you were in the book. Share one with the club when it's ready, or keep it to yourself.",
    notesYouVeLeft: "Notes you've left",
    save: "Save",
    cancel: "Cancel",
    open: "open",
    edited: " · edited",
    shared: (x) => `shared${x} ›`,
    asAQuote: " as a quote",
    noteActions: "Note actions",
    shareWithTheClub: "Share with the club",
    shareAndFlagFor: "Share and flag for the meeting",
    takeItBackFrom: "Take it back from Talk",
    edit: "Edit",
    delete: "Delete",
    deleteThisNote: "Delete this note?",
    postItToTalk: (x, x2, x3) => `Post it to Talk at ${x}${x2}${x3}?`,
    flaggedForTheMeeting: ", flagged for the meeting",
    share: "Share",
    someoneHasRepliedSo: "Someone has replied, so it stays in Talk.",
    openItInTalk: "Open it in Talk ›",
    aPassageFromThe: "A passage from the book",
    keptInTheBook: "Kept in the book's voice. Share it to Talk later if you like.",
    backToAPlain: "Back to a plain note",
    saveAsAPassage: "Save as a passage from the book",
    pasteThePassage: "Paste the passage",
    noteToSelf: "Note to self",
    whereInTheBook: (chipText) => `Where in the book: ${chipText}`,
    saveNote: "Save note",
    whereInTheBook2: "Where in the book this is about",
    whereIAm: (defaultPosition) => `Where I am · ${defaultPosition}%`,
    theNoteSitsAt: "The note sits at your spot.",
    somewhereElse: "Somewhere else",
    percentThroughTheBook: "Percent through the book.",
    percent: "Percent",
    waitingAt: (spot, x) => `Waiting at ${spot} · ${x}`,
    for: (name) => `for ${name}`,
    forEveryone: "for everyone",
    yourNote: "Your note",
    deleteItItS: "Delete it? It's taken back from anyone it reached.",
    keep: "Keep",
};
//# sourceMappingURL=notes.js.map